import NavBar from './NavBar';
import Footer from './Footer';
import '../styles/AboutMe.css';
import profilePic from '../assets/untitledpenguin.jpg';

const AboutMe = () => {
    return (
        <div className="grid-container">
            <NavBar />
            <div className="about-me-title">
                <p>About Me</p>
                <img 
                    src={profilePic} 
                    alt="Profile of Jiaqi Wang" 
                    className="profile-picture" 
                />
            </div>
            <div className="about-me-content">
                <p>
                    Hi！My name is Jiaqi（家琪 in Chinese）, I’m a young and curious urbanist based in London. Before moving to the UK, I had the opportunity to study in the Netherlands, Germany, and China. 
                    My diverse experiences reflect my belief that learning from various fields brings fresh inspiration and unique perspectives to urban design. 
                </p>
                <p>
                    <strong>Current Focus 🔍 (2024)</strong><br/>
                    This year, I have immersed myself in Machine Learning and GHPython Plugin Development. After completing the Machine Learning Specialization offered by DeepLearning.AI and Stanford Online, I applied what I learned in a Rhino 8 environment using Python 3.0, NumPy, and Pandas. This effort culminated in my latest project, <a href="https://aquaplayground.vercel.app/projects/AI/ai1">Generative cities</a>. 
                    </p>
                <p>
                    Simultaneously, I am developing and testing my Grasshopper toolkit, <a href="https://pelicanflow.vercel.app/projects/Documentation">PelicanFlow</a>. This toolkit aims to optimize data management and massing generation workflows in master planning and urban design projects. The latest progress can be seen <a href="https://aquaplayground.vercel.app/projects/AI/cd1">here</a>. 
                    </p>
                    <p>   Currently, I am continuing my studies in the Deep Learning Specialization to deepen my understanding and explore the potential unlocked by more advanced algorithms related to image recognition and time-series data processing. I believe this knowledge will provide valuable insights and inspiration for advancing deep learning development within the Architecture, Engineering, and Construction (AEC) field. 🌆🔍
                </p>
                <p>
                    <strong>Strengths 🧩</strong><br/>
                    - Problem-Solving Enthusiast: Always excited to tackle new challenges and find creative solutions.<br/>
                    - Visualization Wizard: Skilled at simplifying complex ideas and presenting them to diverse audiences.
                </p>
                <p>
                    <strong>Educational Background 🎓</strong><br/>
                    - MPhil in Planning, Growth and Regeneration: University of Cambridge<br/>
                    - MSc in Architecture and Building Science(Cum Laude): TU Delft<br/>
                    - Bachelor in Architecture(Hons): Tongji University<br/>
                    - Exchange Student: TU Munich
                </p>
                <p>
                    <strong>Skill Set 💼</strong><br/>
                    - <strong>Programming:</strong> Python (NumPy, Pandas, scikit-learn, matplotlib), Grasshopper+RhinoScript, Jupyter Notebook, C#<br/>
                    - <strong>Design & Visualization:</strong> Adobe Illustrator, Photoshop, InDesign, Premiere, Enscape, Vray, Hand Sketching<br/>
                    - <strong>Statistics:</strong> Neural Networks and Convolutional Neural Network, Supervised Machine Learning (Random Forest, Logistic Regression, Linear Regression), KNN<br/>
                    - <strong>Data Structures:</strong> Solid understanding of arrays, linked lists, stacks, queues, hash tables, balanced search trees, and graphs
                </p>
                <p>
                    <strong>Long-term Motivation 🌍</strong><br/>
                    I’m passionate about leveraging technology to address social and climate challenges, with a strong commitment to making a positive impact.
                </p>
            </div>
            <Footer />
        </div>
    );
};

export default AboutMe;